import * as React from 'react';
import { Input as TextInput, Textarea } from '../../../components/ui';
import {Link} from '../../elements';
import {FormAuthElement} from './SignUpAuthComponent.style';
import {SignUpAuthMiniComponent} from './SignUpAuthComponent';
import {Button} from '../../../components/ui/button';

export const SignInAuthMiniComponent = ({setComponentActivated}) : JSX.Element => {
  return(
    <div className='center'>
      <span>Já tem uma conta? <Link onPress={()=> setComponentActivated('signin')}>Faça seu Login!</Link></span>
    </div>
  )
}

export const SignInAuthComponent = ({componentActivated, account, setComponentActivated, handleSubmit, loading}) : JSX.Element => {
  const [signup, setSignup] = React.useState({})
  const [errors, setErrors] = React.useState({})

  function updateFormValue({target}){
    const {value, name} = target;
    switch(name){
      case 'name':
        setErrors({...errors, name: undefined});
        break;
      case 'email':
        setErrors({...errors, email: undefined});
        break;
    }
    setSignup({...signup, [name]: value})
  }

  function validateInputElement({target}){
    const {value, name} = target;
    switch(name){
      case 'name':
        if(value.split(' ').length < 2) setErrors({...errors, name: 'Digite nome e sobrenome'});
        break;
      case 'email':
        if( !(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) ) setErrors({...errors, email: 'Digite um email válido'});
        break;
    }
  }
  const submitSignIn = (event) => {
    handleSubmit({event, componentActivated});
  }
  return(
   <div>
    <div className="card">
      <div className="card-content">
        <FormAuthElement onSubmit={submitSignIn} className="SignUpAuth" action="">
          <div className="row">
            <div className="col s12 center"><img src="https://millbody.com/wp-content/uploads/2023/06/logo-personal-millbody.svg" alt="Millbody Account" width="120" /></div>
            <div className="col s12">
              <h3>Faça seu Login com {account.name}</h3>
              <p className="center">Faça seu Login com sua conta Personal Millbody. A mesma que deu cadastro para {account.name} ou outra conta.</p>
            </div>
          </div>
          <div className="row">
            <TextInput 
              name="email" 
              label="E-mail" 
              value={signup.email || ''}  
              s={12} 
              type="email"
              onChange={updateFormValue}
              onBlur={validateInputElement}
              error={errors.email}
              inputClassName={errors?.email ? 'invalid' : ' '}
            />
            <TextInput 
              name="password" 
              label="Senha" 
              value={signup.password || ''} 
              type="password"  
              s={12} 
              onChange={updateFormValue}
              onBlur={validateInputElement}
              error={errors.password}
              inputClassName={errors?.password ? 'invalid' : ' '}
            />
          </div>
          <div className="row">
            <div className="col s12">
              <Link onPress={()=> setComponentActivated('signin')}>Esqueceu a senha?</Link>
            </div>
          </div>
          <div className="row">
            <div className="col s12 center"><Button type="submit" loading={loading} className="btn btn-primary">Entrar</Button></div>
          </div>
        </FormAuthElement>
      </div>
    </div>
    <div className="card">
      <div className="card-content">
        <SignUpAuthMiniComponent setComponentActivated={setComponentActivated} />
      </div>
    </div>
    </div> 
  )
}